<template>
  <button
    class="universal-button"
    :class="{
      [size]: true,
      [variant]: true,
      block,
      glow,
    }"
    @click="$emit('click', $event)"
  >
    <span class="icon">
      <slot name="icon"></slot>
    </span>
    <slot></slot>
    <CaretIcon v-if="caret" class="caret"/>
  </button>
</template>

<script>
import CaretIcon from '@/assets/inlineicons/caret-right.svg?inline';

export default {
  components: {
    CaretIcon,
  },
  props: {
    size: {
      type: String,
      default: 'small',
    },
    variant: {
      type: String,
      default: 'primary',
    },
    block: {
      type: Boolean,
      default: false,
    },
    glow: {
      type: Boolean,
      default: false,
    },
    caret: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: Object,
    },
  },
};
</script>

<style lang="scss" scoped>
.universal-button {
  @include reset-button;

  font-weight: 700;
  margin: 0 auto;
  transition: all .5s;
  // Sizes
  &.large {
    font-size: 16px;
    padding: 25px 25px;
    @media screen and (min-width: $screen-md) {
      font-size: 20px;
      padding: 25px 50px;
    }

  }
  &.small {
    font-size: 16px;
    padding: 16px 35px;
    @media screen and (min-width: $screen-md) {
      padding: 16px 50px;
    }

  }
  // Variants
  &.primary {
    background-color: $primary;
    color: white;
    &:hover {
      background-color: white;
      color: $primary;
    }
  }
  &.white {
    background-color: white;
    color: $primary;
  }
  // Other mods
  &.block {
    display: block;
    width: 100%;
  }
  &.glow {
    box-shadow: 3px 10px 20px 0 rgba($primary,0.2);
  }
  &:hover {
    box-shadow: 3px 15px 30px 0 rgba(0,0,0,0.35);
    transform: translateY(-5px);
  }

  // Children
  .caret {
    transition: all .5s;
    margin-left: 25px;
  }
  .icon svg {
    display: inline-block;
    height: 32px;
    margin-bottom: -8px;
    margin-right: 25px;
  }

  @media screen and (min-width: $screen-md) {
    &.small {
      padding: 16px 50px;
    }
    &.large {
      padding: 25px 50px;
    }
  }
}
</style>
